import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Home from "@/pages/Home";
import Placeholder from "@/pages/Placeholder";
import WorkPage from "@/pages/WorkPage";
import AboutPage from "@/pages/AboutPage";
import ClayProductsPage from "@/pages/ClayProductsPage";
import ContactPage from "@/pages/ContactPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const staticMode =
    typeof window !== "undefined" &&
    window.location.search.includes("static");

  const content = (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/clay-products" element={<ClayProductsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </BrowserRouter>
  );

  return (
    <div className="App">
      {staticMode ? (
        content
      ) : (
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          {content}
        </ReactLenis>
      )}
    </div>
  );
}

export default App;
